import type { Prompt } from "@1js/pl-card-components";
import { PromptCommand } from "@1js/pl-card-components";
import type { Group } from "@1js/pl-types";
import { makeStyles, shorthands, tokens } from "@fluentui/react-components";
import * as React from "react";
import type { WebPrompt } from "../../data";
import { Actions } from "./Actions.web";

type DetailsProps = {
  prompt: WebPrompt | Prompt;
  isBookmarkEnabled?: boolean;
  isBookmarked?: boolean;
  isPromptSavingEnabled?: boolean;
  isPromptSharingEnabled?: boolean;
  isPromptSharingViaEmailEnabled?: boolean;
  isPromptCopyLinkEnabled?: boolean;
  onBookmarkToggled?: (prompt: Prompt, value: boolean) => Promise<void>;
  onShareClicked?: (prompt: Prompt) => void;
  onCopyClicked?: (prompt: Prompt) => void;
  onDelete?: (prompt: Prompt) => void;
  onTryInAppBadgeAction?: (
    prompt: Prompt,
    product: string,
    tagRef: React.MutableRefObject<null>
  ) => void;
  isPromptSharingToWorkgroupEnabled?: boolean;
  onShareToWorkgroupClicked?: (prompts: Prompt[]) => void | Promise<void>;
  groups?: Group[];
  isPromptRemovingFromWorkgroupEnabled?: boolean;
  onRemoveFromWorkgroupClicked?: (
    prompts: Prompt[],
    groupIds: string[]
  ) => void;
  selectedGroupId?: string;
};

const useStyles = makeStyles({
  bodyContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "unset",
    alignSelf: "stretch",
    backgroundColor: tokens.colorNeutralBackground1,
    boxShadow: tokens.shadow2,
    ...shorthands.padding("24px"),
    ...shorthands.gap("24px"),
    ...shorthands.borderRadius("12px"),
    ...shorthands.border("1px", "solid", tokens.colorTransparentStroke),

    "@media (max-width: 540px)": {
      ...shorthands.padding("16px"),
    },
  },
});

export const Detail: React.FC<DetailsProps> = ({
  prompt,
  isBookmarked,
  isBookmarkEnabled,
  isPromptSavingEnabled,
  isPromptSharingEnabled,
  isPromptSharingViaEmailEnabled,
  isPromptCopyLinkEnabled,
  onBookmarkToggled,
  onShareClicked,
  onCopyClicked,
  onDelete,
  onTryInAppBadgeAction,
  isPromptSharingToWorkgroupEnabled,
  onShareToWorkgroupClicked,
  groups,
  isPromptRemovingFromWorkgroupEnabled,
  onRemoveFromWorkgroupClicked,
  selectedGroupId,
}) => {
  const styles = useStyles();
  return (
    <div className={styles.bodyContainer}>
      <div data-testid="detail-description">
        <PromptCommand command={prompt.DisplayText} appearance={"web"} />
      </div>
      <Actions
        prompt={prompt}
        isBookmarkEnabled={isBookmarkEnabled}
        isPromptSavingEnabled={isPromptSavingEnabled}
        isPromptSharingEnabled={isPromptSharingEnabled}
        isPromptSharingViaEmailEnabled={isPromptSharingViaEmailEnabled}
        isBookmarked={isBookmarked}
        isPromptCopyLinkEnabled={isPromptCopyLinkEnabled}
        onBookmarkToggled={onBookmarkToggled}
        onShareClicked={onShareClicked}
        onCopyClicked={onCopyClicked}
        onDelete={onDelete}
        onTryInAppBadgeAction={onTryInAppBadgeAction}
        isPromptSharingToWorkgroupEnabled={isPromptSharingToWorkgroupEnabled}
        onShareToWorkgroupClicked={onShareToWorkgroupClicked}
        groups={groups}
        isPromptRemovingFromWorkgroupEnabled={
          isPromptRemovingFromWorkgroupEnabled
        }
        onRemoveFromWorkgroupClicked={onRemoveFromWorkgroupClicked}
        selectedGroupId={selectedGroupId}
      />
    </div>
  );
};
